import { render, staticRenderFns } from "./i18n.en.vue?vue&type=template&id=4d4ff186&"
import script from "./i18n.en.vue?vue&type=script&lang=js&"
export * from "./i18n.en.vue?vue&type=script&lang=js&"
import style0 from "./i18n.en.vue?vue&type=style&index=0&id=4d4ff186&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports